import React from 'react';
import { Outlet } from 'react-router-dom';
import { MainContainer } from './styles';

interface AppPageProps {}

const AppPage: React.FC<AppPageProps> = () => {
	return (
		<MainContainer>
			<Outlet />
		</MainContainer>
	);
};

export default AppPage;
